import * as Yup from 'yup';

export const UpdatePackageStatusSchema = Yup.object().shape({
  status: Yup.string().min(1).required('Status is required'),
});

export type UpdatePackageStatusDataType = Yup.InferType<
  typeof UpdatePackageStatusSchema
>;

type InitialValues = {
  status: string;
};

export const UpdatePackageStatusInitialValues: InitialValues = {
  status: '',
};

export interface IUpdatePackageStatusResponse {}

export interface IUpdatePackageStatusRequest {
  // clearer: string;
  status: string;
  cargoId: string;
}
